import React from 'react';

export default function ProductivityRatioBar({ productiveMs = 0, neutralMs = 0 }) {
  const total = productiveMs + neutralMs;

  if (total <= 0) {
    return <div className="productivity-ratio-bar productivity-ratio-bar--empty" />;
  }

  const productivePct = (productiveMs / total) * 100;
  const neutralPct = 100 - productivePct;

  return (
    <div
      className="productivity-ratio-bar"
      title={`Productive ${Math.round(productivePct)}% / Neutral ${Math.round(neutralPct)}%`}
    >
      <div className="productivity-ratio-bar__track">
        <div
          className="productivity-ratio-bar__segment productivity-ratio-bar__productive"
          style={{ width: `${productivePct}%` }}
        />
        <div
          className="productivity-ratio-bar__segment productivity-ratio-bar__neutral"
          style={{ width: `${neutralPct}%` }}
        />
      </div>
    </div>
  );
}
